import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import img1 from "../../assets/image/Appimage/img1.jpg";
import img2 from "../../assets/image/Appimage/AppDevlopment.png";
import img3 from "../../assets/image/Appimage/img1.avif";
import img4 from "../../assets/image/Appimage/img2.avif";
import img5 from "../../assets/image/Appimage/img4.avif";
import img6 from "../../assets/image/Appimage/img6.avif";
import img8 from "../../assets/image/Appimage/img8.avif";

import Footer from "../Footer/Footer";
import "../../assets/css/AppDevelopment.css";

import {
  FaEnvelope,
  FaSkype,
  FaPhone,
  FaUser,
  FaGlobe,
  FaDollarSign,
  FaChartLine,
  FaPen,
  FaPaperPlane,
  FaBuilding,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl"
const AppDevelopment = () => {

  const [meta, setMeta] = useState({});

  useEffect(() => {
    const Gamedevelopment = data[0]?.services_page_App_Development;

    if (Gamedevelopment) {
      setMeta(Gamedevelopment);
    }
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top-left corner
  }, []);

  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);

  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const form = useRef();

  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_z73r4mc",
        "template_evcmg1l",
        form.current,
        "EscxBRJBS9wDUay2E"
      )
      .then(
        (result) => {
          alert("Enquiry sent successfully!");
          setIsOpenEnquiry(false);
          setFormDataEnquiry({
            name: "",
            email: "",
            phone: "",
            whatsapp: "",
            companyName: "",
            companyService: "",
            serviceType: "",
            country: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send enquiry. Please try again.");
        }
      );
  };

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      easing: "ease-in-out", // Easing function
      once: true, // Whether animation should happen only once
    });
  }, []);

  const sectionStyle = {
    backgroundImage: `url(${img2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "50vh",
    position: "relative",
    zIndex: 1,
    overflow: "hidden",
    color: "#fff",
  };

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 2,
  };

  const contentStyle = {
    position: "relative",
    zIndex: 3,
  };

  const [hoveredCard, setHoveredCard] = useState(null);

  const services = [
    {
      title: "Native iOS Development",
      tech: "Swift & Objective-C",
      description:
        "High-performance native iOS applications with seamless integration to Apple's ecosystem. Our expert developers leverage the latest iOS frameworks and tools.",
      features: [
        "App Store Optimization",
        "Core Data Integration",
        "Push Notifications",
        "In-App Purchases",
      ],
      image: img2,
    },
    {
      title: "Native Android Development",
      tech: "Java & Kotlin",
      description:
        "Robust Android applications optimized for all devices and screen sizes. We follow Google's Material Design principles for consistent user experiences.",
      features: [
        "Play Store Publishing",

        "Firebase Integration",
        "Material Design",
        "Android Jetpack",
      ],
      image: img3,
    },
    {
      title: "Cross-Platform Solutions",
      tech: "React Native & Flutter",
      description:
        "Build once, deploy everywhere. Our cross-platform solutions provide native performance while reducing development time and costs significantly.",
      features: [
        "Code Reusability",
        "Native Performance",
        "Rapid Development",
        "Cost Effective",
      ],
      image: img4,
    },
    {
      title: "Backend Integration",
      tech: "Node.js, .NET, Python",
      description:
        "Powerful server-side solutions and seamless API integrations. We build scalable backend systems that grow with your business needs.",
      features: [
        "RESTful APIs",
        "Database Design",
        "Cloud Integration",
        "Real-time Features",
      ],
      image: img5,
    },
    {
      title: "UI/UX Design",
      tech: "Figma & Adobe XD",
      description:
        "User-centric design focusing on intuitive interfaces and exceptional user experiences. We create designs that engage and convert users.",
      features: [
        "Wireframing",
        "Prototyping",
        "User Testing",
        "Design Systems",
      ],
      image: img6,
    },
    {
      title: "Quality Assurance",
      tech: "Automated & Manual Testing",
      description:
        "Rigorous testing protocols ensuring stability, security, and performance across all supported devices and platforms.",
      features: [
        "Automated Testing",
        "Device Testing",
        "Performance Testing",
        "Security Audits",
      ],
      image: img8,
    },
  ];

  const process = [
    {
      step: "01",
      title: "Discovery & Planning",
      description:
        "We dive deep into understanding your business goals, target audience, and technical requirements to create a comprehensive project roadmap.",
      duration: "1-2 Weeks",
    },
    {
      step: "02",
      title: "Design & Prototyping",
      description:
        "Our design team creates wireframes, mockups, and interactive prototypes to visualize your app before development begins.",
      duration: "2-3 Weeks",
    },
    {
      step: "03",
      title: "Development Sprint",
      description:
        "Using agile methodology, we build your app with regular updates and feedback loops to ensure we're on the right track.",
      duration: "6-12 Weeks",
    },
    {
      step: "04",
      title: "Testing & QA",
      description:
        "Comprehensive testing across multiple devices, platforms, and scenarios to ensure bug-free, high-performance applications.",
      duration: "2-3 Weeks",
    },
    {
      step: "05",
      title: "Deployment",
      description:
        "We handle the complete app store submission process, ensuring compliance with all guidelines and requirements.",
      duration: "1-2 Weeks",
    },
    {
      step: "06",
      title: "Support & Maintenance",
      description:
        "Ongoing support, updates, and feature enhancements to keep your app current and competitive in the market.",
      duration: "Ongoing",
    },
  ];

  const technologies = [
    {
      category: "Mobile Frameworks",
      techs: [
        { name: "React Native", level: 95 },
        { name: "Flutter", level: 90 },
        { name: "Ionic", level: 85 },
        { name: "Xamarin", level: 80 },
      ],
    },
    {
      category: "Native Development",
      techs: [
        { name: "Swift", level: 95 },
        { name: "Kotlin", level: 90 },
        { name: "Objective-C", level: 85 },
        { name: "Java", level: 90 },
      ],
    },
    {
      category: "Backend Technologies",
      techs: [
        { name: "Node.js", level: 95 },
        { name: ".NET Core", level: 90 },
        { name: "Python", level: 85 },
        { name: "PHP", level: 80 },
      ],
    },
    {
      category: "Databases",
      techs: [
        { name: "MongoDB", level: 90 },
        { name: "PostgreSQL", level: 85 },
        { name: "Firebase", level: 95 },
        { name: "Redis", level: 80 },
      ],
    },
  ];

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>
      <div className="bg-white">
        <Helmet>
          <title>{meta?.title || "Services-App_Development - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Our curriculum."
            }
          />
        </Helmet>
        {/* Enquiry Form */}
        {isOpenEnquiry && (
          <div
            onClick={handleBackdropClick}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(8px)",
              zIndex: 1050,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                maxHeight: "100vh",
                background: "#fff",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Fixed Header */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#00b7eb",
                  color: "#ffffff",
                  padding: "15px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    textAlign: "center",
                  }}
                >
                  Enquiry Form
                </h3>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#ffffff",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Scrollable Form */}
              <div
                style={{
                  padding: "20px",
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 70px)", // Adjust based on header height
                }}
              >
                <form ref={form} onSubmit={handleSubmitForm}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {/* Full Name */}
                    <div>
                      <FaUser
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formDataEnquiry.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter full name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <FaEnvelope
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formDataEnquiry.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email"
                        style={inputStyle}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <FaPhone
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formDataEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone"
                        style={inputStyle}
                      />
                    </div>

                    {/* WhatsApp */}
                    <div>
                      <IoLogoWhatsapp
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">WhatsApp</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formDataEnquiry.whatsapp}
                        onChange={handleInputChange}
                        placeholder="Enter WhatsApp"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Name */}
                    <div>
                      <FaBuilding
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        value={formDataEnquiry.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Service */}
                    <div>
                      <IoMdBuild
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Service</label>
                      <select
                        name="companyService"
                        value={formDataEnquiry.companyService}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt</option>
                        <option value="LLP">LLP</option>
                        <option value="Startup">Startup</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>

                    {/* Service Type */}
                    <div>
                      <MdOutlineMiscellaneousServices
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Type of Service</label>
                      <select
                        name="serviceType"
                        value={formDataEnquiry.serviceType}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Drone">Drone Solutions</option>
                        <option value="Robotics">Robotics Solutions</option>
                        <option value="IOT">Iot Solutions</option>
                        <option value="AI">Artificial Intelligence</option>
                        <option value="Software">Software Development</option>
                        <option value="App">App Development</option>
                        {/* <option value="Game">Game Development</option> */}
                        <option value="Website">Website Development</option>
                        <option value="AR & VR Development">AR & VR Apps</option>
                        {/* <option value="Casino Api">Casino API</option> */}
                        {/* <option value="Devops Solutions">DevOps</option> */}
                        {/* <option value="It Support">IT Support</option> */}
                        <option value="Training Programs">Training</option>
                        {/* <option value="Digital Marketing">
                        Digital Marketing
                      </option> */}
                      </select>
                    </div>

                    {/* Country */}
                    <div>
                      <FaGlobe
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formDataEnquiry.country}
                        onChange={handleInputChange}
                        placeholder="Enter country"
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formDataEnquiry.message}
                      onChange={handleInputChange}
                      required
                      rows={1}
                      placeholder="Tell us about your requirements..."
                      style={{
                        ...inputStyle,
                        resize: "vertical",
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div
                    className="mt-1 margin-top-home"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      type="submit"
                      style={{
                        background: "#00b7eb",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "25px",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaPaperPlane style={{ marginRight: "8px" }} />
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Header Section */}
        {/* <div style={sectionStyle} className="d-flex align-items-center" data-aos="fade-down">
        <div style={overlayStyle}></div>
        <div className="container" style={contentStyle}>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <nav aria-label="breadcrumb" className="mb-4" data-aos="fade-right" data-aos-delay="100">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/" className="text-white fw-bold text-decoration-none">
                      Home
                    </a>
                  </li>
                  <li className="breadcrumb-item text-white fw-bold" aria-current="page">
                    App Development
                  </li>
                </ol>
              </nav>
              <h3 className="display-5 fw-bold mb-3" data-aos="fade-right" data-aos-delay="200">
                App Development
              </h3>
            </div>
          </div>
        </div>
      </div> */}

        <div
          className="position-relative min-vh-50 app-bg d-flex align-items-center justify-content-center bg-dark text-white"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="position-absolute top-0 start-0 w-100 h-100 opacity-20"></div>
          <div className="container position-relative">
            <div className="row align-items-center">
              <div className="col-lg-6 software-content">
                <nav
                  aria-label="breadcrumb"
                  className="mb-4"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="text-white fw-bold breadcrumb-item"
                      aria-current="page"
                    >
                      App Development
                    </li>
                  </ol>
                </nav>
                <h3
                  className="display-6 fw-bold mb-3"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  App Development
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* Hero Section */}
        <section className="min-vh-70 mt-4 d-flex align-items-center position-relative overflow-hidden">
          <div className="container">
            <div className="row align-items-center min-vh-70">
              <div
                className="col-lg-8 col-md-8"
                data-aos="fade-right"
                data-aos-delay="300"
              >
                <div className="pe-lg-5">
                  <div className="mb-4">
                    <button
                      className=" btn border  border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                      style={{ color: "#00b7eb" }}
                      data-aos="zoom-in"
                      data-aos-delay="400"
                    >
                      App Development
                    </button>
                  </div>
                  <h3
                    className="display-5 fw-bold text-dark mb-3"
                    data-aos="fade-up"
                    data-aos-delay="500"
                  >
                    Android <span className="font-red">Development</span>
                  </h3>
                  <p
                    className="font-para fw-semibold  mb-4"
                    data-aos="fade-up"
                    data-aos-delay="600"
                  >
                    We offer both native and cross-platform solutions, leveraging
                    a rich technology stack to ensure each app is optimized for
                    performance and user experience
                  </p>
                  <div className="d-flex flex-column flex-sm-row gap-3 mb-5">
                    <button
                      className="btn btn-red text-white fw-semibold px-4 py-2 w-35 w-sm-auto"
                      data-aos="zoom-in"
                      data-aos-delay="700"
                      onClick={() => setIsOpenEnquiry(true)}
                    >
                      Start Your Project
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-4  d-none d-lg-block d-md-block"
                data-aos="fade-left"
                data-aos-delay="900"
              >
                <div className="position-relative">
                  <img
                    src={img1}
                    alt="Descriptive Alt Text"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      width: "400px",
                      height: "300px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-4 bg-light" data-aos="fade-up">
          <div className="container">
            <div className="text-center mb-3">
              <button
                className=" btn border mb-1 border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                style={{ color: "#00b7eb" }}
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                Our Services
              </button>
              <h3
                className="display-6  fw-bold text-dark mb-2"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Complete App Development{" "}
                <span className="font-red"> Solutions</span>
              </h3>
              <p
                className=" font-para fw-semibold  mb-4"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                From native iOS and Android apps to cross-platform solutions, we
                deliver comprehensive mobile development services
              </p>
            </div>
            <div className="row g-4">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay={100 * (index + 1)}
                >
                  <div
                    className="card bg-dark text-white border-0 h-100 shadow-lg position-relative overflow-hidden"
                    style={{
                      transform:
                        hoveredCard === index
                          ? "translateY(-10px) scale(1.02)"
                          : "translateY(0) scale(1)",
                      transition: "all 0.4s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={() => setHoveredCard(index)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <div
                      className="position-absolute w-100 h-100 bg-white text-dark"
                      style={{
                        transform:
                          hoveredCard === index ? "scale(1.1)" : "scale(1)",
                        transition: "all 0.4s ease",
                      }}
                    ></div>
                    <div className="card-body p-0 position-relative">
                      <div className="position-relative">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="card-img-top"
                          style={{ height: "150px", objectFit: "cover" }}
                        />
                      </div>
                      <div className="p-3">
                        <h2 className="h4  p-1 fw-bold text-danger">
                          {service.title}
                        </h2>
                        <p className="font-card-para text-dark fw-medium  p-1">
                          {service.description}
                        </p>
                      </div>

                      {/* <button className="btn btn-red text-white fw-semibold px-4 py-2">
                      Learn More
                    </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-4" data-aos="fade-up">
          <div className="container">
            <div className="text-center mb-4">
              <button
                className=" btn border   border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                style={{ color: "#00b7eb" }}
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                Our Process
              </button>
              <h3
                className="display-5 fw-bold text-dark mb-3"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Concept to <span className="font-red">Launch</span>
              </h3>
              <p
                className=" font-para mb-4 fw-semibold  mx-auto"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                Our proven 6-step development process ensures your app is built
                efficiently and exceeds expectations
              </p>
            </div>
            <div className="row g-4">
              {process.map((step, index) => (
                <div
                  key={index}
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay={100 * (index + 1)}
                >
                  <div
                    className="card bg-light text-dark border-0 h-100 shadow-lg position-relative overflow-hidden"
                    style={{
                      transform:
                        hoveredCard === `process-${index}`
                          ? "translateY(-5px)"
                          : "translateY(0)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={() => setHoveredCard(`process-${index}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <div className="position-absolute top-0 end-0 m-3 d-md-flex">
                      <span className="bg-red text-white px-2 py-1 rounded-pill">
                        {step.duration}
                      </span>
                    </div>
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-4">
                        <h2 className="h4 fw-bold text-dark mb-0">
                          {step.title}
                        </h2>
                      </div>
                      <p className="font-card-para fw-medium mb-4">
                        {step.description}
                      </p>
                      <div className="progress mb-3" style={{ height: "6px" }}>
                        <div
                          className="progress-bar bg-danger"
                          style={{
                            width:
                              hoveredCard === `process-${index}` ? "100%" : "0%",
                            transition: "width 0.8s ease",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <Footer data-aos="fade-up" data-aos-delay="100" />
      </div>
    </HelmetProvider>
  );
};

export default AppDevelopment;
